export const initialState = () => ({
  loading: {
    message: "",
    show: false
  },
  typeOfferFormSelected: null,
  isFromEditing: false
})
